import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import { Page } from 'react-facebook';
import { Flex, Link } from '@chakra-ui/react';

import Card from '../../../components/Card';

function FollowUs(): React.ReactElement {
  const [skipSsrFb, setSkipSsrFb] = useState(false);

  useEffect(() => {
    setSkipSsrFb(true);
  }, []);

  return (
    <Card p="12px">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        sx={{
          '@media (min-width: 768px)': {
            flexDirection: 'row',
          },
        }}
      >
        <Flex display="inline-flex">
          {skipSsrFb && <Page href="https://www.facebook.com/news24moldova" smallHeader adaptContainerWidth />}
        </Flex>
        <Flex display="inline-flex">{i18n.t('main.widgets.followUs.or')}</Flex>
        <Flex display="inline-flex">
          <Link href="https://t.me/news24moldova" target="_blank" rel="noopener nofollow noindex noreferrer">
            {i18n.t('main.widgets.followUs.telegram')}
          </Link>
        </Flex>
      </Flex>
    </Card>
  );
}

export default FollowUs;
